import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';
import type { GallerySortName } from '@sorare/core/src/contexts/config';
import { useGQLSearchContext } from '@sorare/core/src/contexts/graphql-search';
import { useBackendI18nSortByItems } from '@sorare/core/src/hooks/search/useI18nSortByItems';
import { useMarketplaceLifecycle } from '@sorare/core/src/hooks/useMarketplaceLifecycle';

type Props = {
  indexes: GallerySortName[];
};

export const BackendSortCards = ({ indexes }: Props) => {
  const ctx = useGQLSearchContext();
  const { updateSort } = useMarketplaceLifecycle();

  const items = useBackendI18nSortByItems(indexes);

  const currentSort = ctx?.sorts[0] ?? indexes[0];
  const selectedSort = items.find(i => i.value === currentSort) ?? items[0];

  return (
    <FilterInDropdown buttonLabel={selectedSort?.label}>
      {({ closeDropdown }) => (
        <RadioGroup
          options={items}
          value={selectedSort?.value}
          name="draft-sort-type"
          onChange={(value: string) => {
            const selected = items.find(i => i.value === value);
            if (selected) {
              ctx?.setSearchParams(prev => {
                prev.delete('p');
                prev.set('s', selected.value);
                return prev;
              });
              updateSort(selected.index);
              setTimeout(() => closeDropdown(), 100);
            }
          }}
        />
      )}
    </FilterInDropdown>
  );
};
